import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import BeaufortDetailedAccount from './BeaufortDetailedAccount';
import UtilitiesService from '../../../../../service/UtilitiesService';

class BeaufortDetailedAccountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    const { account, } = this.props;
    this.setState({ show: false, }, () => {
      UtilitiesService.getEbillingsByAccountId({ accountId: account.id, })
        .then((response) => {
          this.setState({
            updatedAccount: {
              ...account,
              ebillings: response.data.ebillings,
            },
          });
        })
        .catch(() => {
          this.setState({
            updatedAccount: account,
          });
        })
        .finally(() => {
          this.setState({ show: true, });
        });
    });

    // this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, updatedAccount, } = this.state;
    const { account, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Beaufort Tax Account Id:
              {` ${account.id}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <BeaufortDetailedAccount account={updatedAccount} isModal />;
              }
              return undefined;
            })()}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

BeaufortDetailedAccountModal.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
};

export default BeaufortDetailedAccountModal;
